import axiosInstance from "@/utils/axiosInstance";

const baseUrl: string = "api/admin/buildings";

const state = {};

const getters = {};

const mutations = {};

const actions = {
  getAll({commit}, payload: {query: object}) {
    return axiosInstance.get(baseUrl, {params: {
        ...payload.query,
      }}).then((data) => data.data);
  },
  createMounting({ commit }, payload: { building: {  id: number }}) {
    return axiosInstance.post(`${baseUrl}/${payload.building.id}/mountings`, null)
      .then((data) => data.data);
  },
  getUrmetCredential({ commit }, payload: { buildingId: number }) {
    return axiosInstance.get(`${baseUrl}/${payload.buildingId}/urmet-credential`)
      .then((data) => data.data);
  },
  deleteUrmetCredential({ commit }, payload: { buildingId: number }) {
    return axiosInstance.delete(`${baseUrl}/${payload.buildingId}/urmet-credential`)
      .then((data) => data.data);
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
